import { ReactNode } from 'react';
import appStyles from '../App.module.css';
import NavBar, { View } from '../../components/NavBar';
import formStyles from '../FormStart/index.module.css';

type LayoutProps = {
  children?: ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={appStyles.App}>
      <NavBar view={View.DigitalCheckIn} />
      <div className={formStyles.FormContainer}>
        <div className={formStyles.Form}>{children}</div>
      </div>
    </div>
  );
};

export default Layout;
